import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Search, MapPin, Phone, Mail, Globe, ArrowRight } from "lucide-react";
import api from "@/lib/api";
import { PageHero } from "@/components/public/Shared";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

export default function BawasluTerdekat() {
  const [offices, setOffices] = useState([]);
  const [search, setSearch] = useState("");

  const load = (s = "") => api.get(`/offices${s ? `?search=${encodeURIComponent(s)}` : ""}`).then((r) => setOffices(r.data));
  useEffect(() => { load(); }, []);

  return (
    <div>
      <PageHero eyebrow="Direktori" title="Bawaslu Terdekat"
        description="Temukan informasi kantor Bawaslu di wilayah Anda di seluruh Sulawesi Tenggara." />
      <div className="container-page py-10">
        <form onSubmit={(e) => { e.preventDefault(); load(search); }} className="flex gap-2 max-w-xl mb-8">
          <div className="flex items-center flex-1 bg-white border border-slate-200 rounded-lg px-3">
            <Search className="h-4 w-4 text-slate-400" />
            <Input data-testid="office-search" value={search} onChange={(e) => setSearch(e.target.value)} placeholder="Cari Kabupaten/Kota..." className="border-0 shadow-none focus-visible:ring-0" />
          </div>
          <Button type="submit" className="bg-navy text-white">Cari</Button>
        </form>

        <div className="grid lg:grid-cols-3 gap-6">
          <div className="lg:col-span-2 grid sm:grid-cols-2 gap-5" data-testid="office-directory">
            {offices.map((o) => (
              <div key={o.id} className="bg-white border border-slate-200 rounded-xl p-5 hover:shadow-lg transition-shadow flex flex-col">
                <div className="flex items-start justify-between gap-2">
                  <h3 className="font-bold text-navy leading-snug">{o.name}</h3>
                  <span className="text-[10px] font-bold px-2 py-0.5 rounded-full bg-brandred/10 text-brandred shrink-0">{o.level}</span>
                </div>
                <div className="text-sm text-slate-500 mt-3 space-y-1.5 flex-1">
                  <div className="flex gap-2"><MapPin className="h-4 w-4 text-brandred shrink-0 mt-0.5" /> {o.address}</div>
                  <div className="flex gap-2"><Phone className="h-4 w-4 text-brandred shrink-0 mt-0.5" /> {o.phone}</div>
                  <div className="flex gap-2"><Mail className="h-4 w-4 text-brandred shrink-0 mt-0.5" /> {o.email}</div>
                </div>
                <Link to={`/bawaslu-terdekat/${o.id}`} data-testid={`office-detail-${o.id}`} className="inline-flex items-center gap-1.5 text-sm font-bold text-brandred mt-4">
                  Lihat Detail <ArrowRight className="h-4 w-4" />
                </Link>
              </div>
            ))}
            {offices.length === 0 && <div className="col-span-2 text-center py-16 text-slate-400">Tidak ada kantor ditemukan.</div>}
          </div>

          <div className="lg:col-span-1">
            <div className="bg-navy rounded-2xl overflow-hidden sticky top-24 h-80 relative flex items-center justify-center" data-testid="map-placeholder">
              <div className="absolute inset-0 opacity-20" style={{ backgroundImage: "linear-gradient(#1E3E6B 1px, transparent 1px), linear-gradient(90deg, #1E3E6B 1px, transparent 1px)", backgroundSize: "24px 24px" }} />
              <div className="relative text-center text-white px-6">
                <MapPin className="h-10 w-10 text-brandred mx-auto mb-3" />
                <h4 className="font-bold">Peta Wilayah Sulawesi Tenggara</h4>
                <p className="text-xs text-slate-300 mt-2">Peta interaktif menampilkan sebaran {offices.length} kantor Bawaslu di Sulawesi Tenggara.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
